import React from 'react'

export const renderText = (text) => (
  text
    .split('\n')
    .map((item, i) => <span style={{ display: 'block' }} key={i}>{item}</span>)
)
